// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"ProductGrid_sectionContainer__6Vpgp","gridContainer":"ProductGrid_gridContainer__3E74Y","pagination":"ProductGrid_pagination__2cFML"};